// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b9b55e3a","239":"fd889d3c","453":"3defaa9f","455":"bdc3e19f"}[chunkId] + ".chunk.js";
};